<template>
  <mia-checkbox
    class="w-5 h-5"
    :checked="areAllRowsChecked"
    @change="onChange"
  />
</template>

<script>
export default {
  name: 'MiaDatatableCheckAllColumn',

  props: {
    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      areAllRowsChecked: false
    }
  },

  created() {
    // We watch the "displayedRows" property of the Datatable instance,
    // which holds all currently rendered rows
    // If the .isChecked property of a row changed, we can re-calculate if
    // the "All Checked" checkbox must be reflect that state or not
    this.getDatatable().$watch('displayedRows', () => {
      this.determineAllRowsAreChecked()
    })

    // Also perform the check for the initial data
    this.determineAllRowsAreChecked()
  },

  methods: {
    getDatatable() {
      return this.$parent.$parent
    },

    getDisplayedRows() {
      return this.getDatatable().displayedRows
    },

    determineAllRowsAreChecked() {
      if (this.getDisplayedRows().length === 0) {
        return
      }

      this.$nextTick(() => {
        this.areAllRowsChecked = this.getDisplayedRows().every(row => this.isChecked(row))
      })
    },

    onChange(event) {
      this.getDatatable().$emit(event.target.checked ? 'check-all' : 'uncheck-all', this.getEventPayload())
    },

    getEventPayload() {
      const meta = this.column.meta || {}
      const { only } = meta

      if (only) {
        return this.getDisplayedRows().map(row => row[only])
      }

      return this.getDisplayedRows()
    },

    isChecked(row) {
      const meta = this.column.meta || {}
      const isChecked = meta.isChecked || (item => item.isChecked)

      return isChecked(row)
    }
  }
}
</script>
